import Paper from '@mui/material/Paper';
import PropTypes from 'prop-types';
import React, { lazy, Suspense } from 'react';
const Draggable = /*#__PURE__*/ lazy(()=>import('react-draggable'));
const DraggablePaper = ({ titleId, ...other })=>{
    const muiPaper = /*#__PURE__*/ React.createElement(Paper, other);
    return /*#__PURE__*/ React.createElement(Suspense, {
        fallback: muiPaper
    }, /*#__PURE__*/ React.createElement(Draggable, {
        handle: `#${CSS.escape(titleId)}`,
        cancel: '[class*="MuiDialogContent-root"]'
    }, muiPaper));
};
DraggablePaper.propTypes = {
    titleId: PropTypes.string
};
export default DraggablePaper;
